module.exports = require("/buddy/balenciaga-fall22-frontend/src/configuration/jss")